import { Dialog, DialogContent } from '../../ui/dialog'
import { Button } from '../../ui/button'
import { AlertTriangle, X } from 'lucide-react'
import { motion } from 'framer-motion'

interface AccessDeniedModalProps {
  isOpen: boolean
  onClose: () => void
  message?: string
}

export function AccessDeniedModal({ isOpen, onClose, message = 'Access denied. You do not have permission to access this application.' }: AccessDeniedModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-md w-full mx-auto p-0 gap-0 border-0 bg-transparent shadow-none"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="relative bg-white dark:bg-slate-900 rounded-3xl shadow-2xl shadow-black/10 dark:shadow-black/30 overflow-hidden"
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors duration-200 flex items-center justify-center group"
          >
            <X className="h-4 w-4 text-red-600 dark:text-red-400 group-hover:text-red-700 dark:group-hover:text-red-300 transition-colors" />
          </button>

          {/* Content */}
          <div className="px-8 py-10 text-center space-y-6">
            {/* Icon */}
            <div className="mx-auto w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
              <AlertTriangle className="h-8 w-8 text-red-600 dark:text-red-400" />
            </div>

            {/* Heading */}
            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                Access Denied
              </h2>
              <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                {message}
              </p>
            </div>

            {/* Action Button */}
            <div className="pt-2">
              <Button
                onClick={onClose}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-xl transition-colors duration-200"
              >
                Understood
              </Button>
            </div>
          </div>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
